var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "distribution-work-bench" }, [
    _c("div", { staticClass: "work-top" }, [
      _c(
        "div",
        { staticClass: "work-bench-left-top" },
        [_c("sale-list", { attrs: { saleListConfig: _vm.saleListConfig } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-bench-right-top" },
        [_c("info-list", { attrs: { info: _vm.saleInfo } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "work-bottom" }, [
      _c("div", { staticClass: "work-bench-left-bottom" }, [
        _c(
          "div",
          { staticClass: "distribution-overview-item" },
          [
            _c("div", { staticClass: "title-info" }, [_vm._v("分销总览")]),
            _vm._v(" "),
            _c("define-echart", {
              staticClass: "barContainer",
              attrs: { id: "barContainer", option: _vm.saleBarData },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tablewrap" },
              [
                _c("stor-table", {
                  attrs: { sortTableConfig: _vm.sortTableConfig },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "operation-overview-item" }, [
          _c("div", { staticClass: "title-info" }, [_vm._v("运营总览")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tableWrap" },
            _vm._l(_vm.tableData, function (value, key) {
              return _c(
                "div",
                { key: key, staticClass: "table-item" },
                [_c("stor-table", { attrs: { sortTableConfig: value } })],
                1
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "logistics-overview-item" }, [
          _c("div", { staticClass: "title-info" }, [_vm._v("物流总览")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "logistics-chart" },
            [
              _c("define-echart", {
                staticClass: "bar-chart",
                attrs: { id: "stockBarContainer", option: _vm.stockBarData },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pie-chart" },
            [
              _c("define-echart", {
                staticClass: "pie-top",
                attrs: { id: "pieTopContainer", option: _vm.logisticsData },
              }),
              _vm._v(" "),
              _c("define-echart", {
                staticClass: "pie-bottom",
                attrs: {
                  id: "pieBottomContainer",
                  option: _vm.sendLogisticData,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-bench-right-bottom" },
        [_c("info-list", { attrs: { info: _vm.publicInfo } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }